import React, { useState } from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'

const StatRow = ({ title, value }) => (
  <div>
    <div className="d-flex flex-row justify-content-between align-items-center">
      <span className={styles.title}>{title || '--'}</span>
      <span className={styles.score}>{value || '--'}</span>
    </div>
  </div>
)

const KeyStatistics = ({ venueDetails }) => {
  const [activeTab, setActiveTab] = useState('t20i')

  const formatMapping = {
    t20i: 'T20',
    odi: 'ODI',
    test: 'Test',
    womentest: 'Women Test',
    womenodi: 'Women ODI',
    woment20i: 'Women T20',
    ipl: 'IPL'
  }

  const availableFormats = venueDetails?.getVenueDetailsById?.aFormats || []
  const venueStats = venueDetails?.getVenueDetailsById?.venueStats || []

  const tabData = Object.keys(formatMapping)
    .filter((format) => availableFormats.includes(format))
    .map((format) => ({
      title: formatMapping[format],
      value: format
    }))

  const activeStats = venueStats.find((stat) => stat.sMatchFormat === activeTab)
  const firstInningStats = activeStats?.aStatsPerInning?.[0] || {}
  const secondInningStats = activeStats?.aStatsPerInning?.[1] || {}

  const statistics = [
    { title: 'Total Matches', value: activeStats?.nTotalMatches },
    { title: 'Total Cancelled Matches', value: activeStats?.nCancelledMatches },
    { title: 'Average Runs 1st Innings', value: firstInningStats.nAvgRuns },
    { title: 'Average Runs 2nd Innings', value: secondInningStats.nAvgRuns },
    { title: 'Average Wickets 1st Innings', value: firstInningStats.nAvgWkts },
    { title: 'Average Wickets 2nd Innings', value: secondInningStats.nAvgWkts },
    { title: 'Average Strike Rate 1st Innings', value: firstInningStats.nAvgStrikeRate },
    { title: 'Average Strike Rate 2nd Innings', value: secondInningStats.nAvgStrikeRate },
    { title: 'Highest Score', value: activeStats?.oHighestScore?.nScore },
    { title: 'Highest Score Chased', value: activeStats?.oHighestScoreChased?.nScore },
    { title: 'Lowest Score', value: activeStats?.oLowestScore?.nScore },
    { title: 'Lowest Score Defended', value: activeStats?.oLowestScoreDefended?.nScore },
    { title: 'Total Hundreds', value: activeStats?.nTotalHunderd },
    { title: 'Total Fifties', value: activeStats?.nTotalFifty },
    { title: 'Total Sixes', value: activeStats?.nTotalSixes },
    { title: 'Total Fours', value: activeStats?.nTotalFours },
    { title: 'Total Stumpings', value: activeStats?.nStumpings },
    { title: 'Total Times player took 4 wickets', value: activeStats?.nWicket4i },
    { title: 'Total Times player took 5 wickets', value: activeStats?.nWicket5i },
    { title: 'Total Maiden overs', value: activeStats?.nMaidens },
    { title: 'Number of times toss win choose bat', value: activeStats?.nTossWinChooseBat },
    { title: 'Number of times toss win choose bat & won', value: activeStats?.nTossWinChooseBatMatchWin },
    { title: 'Number of times toss win choose bat & loss', value: activeStats?.nTossWinChooseBatMatchLoss },
    { title: 'Number of times toss win choose bowl & won', value: activeStats?.nTossWinChooseBowlMatchWin },
    { title: 'Number of times toss win choose bowl & loss', value: activeStats?.nTossWinChooseBowlMatchLoss }
  ]

  const midpoint = Math.ceil(statistics.length / 2)
  const firstColumnStats = statistics.slice(0, midpoint)
  const secondColumnStats = statistics.slice(midpoint)

  return (
    <section>
      <h2>Key Statistics</h2>
      <div className={`d-flex flex-row ${styles.navs}`}>
        <ul className="d-flex flex-row gap-2">
          {tabData.map((tab, index) => (
            <li
              key={index}
              className={`${styles.tabs} ${activeTab === tab.value ? styles.active : ''}`}
              onClick={() => setActiveTab(tab.value)}
            >
              {tab.title}
            </li>
          ))}
        </ul>
      </div>

      <div className="d-md-flex d-none flex-row gap-3">
        <div className={styles.common_border}>
          {firstColumnStats.map((stat, index) => (
            <React.Fragment key={index}>
              <StatRow title={stat.title} value={stat.value} />
              {index !== firstColumnStats.length - 1 && <div className={styles.line}></div>}
            </React.Fragment>
          ))}
        </div>

        <div className={styles.common_border}>
          {secondColumnStats.map((stat, index) => (
            <React.Fragment key={index}>
              <StatRow title={stat.title} value={stat.value} />
              {index !== secondColumnStats.length - 1 && <div className={styles.line}></div>}
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="d-md-none d-flex">
        <div className="d-flex flex-row gap-3">
          <div className={styles.common_border}>
            {statistics.map((stat, index) => (
              <React.Fragment key={index}>
                <StatRow title={stat.title} value={stat.value} />
                {index !== statistics.length - 1 && <div className={styles.line}></div>}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

KeyStatistics.propTypes = {
  venueDetails: PropTypes.object.isRequired
}

StatRow.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired
}

export default KeyStatistics
